import React from 'react'

import { useNavigation } from '@zet/common/hooks/useNavigation'
import { colors as zetColors } from '@zet/design-system'
import { Stack, XStack } from '@zet/design-system/layout'
import Pressable from '@zet/design-system/pressable'
import AssignedOutlined from '@zet/design-system/svg/AssignedOutlined'
import { B4, B5, SH3 } from '@zet/design-system/typography'

import { useGetLeadCount } from '../../api/homeScreenBridge/hooks'
import { i18n } from '../../localization'
import CalenderExpiredFilled from '../../svg/CalenderExpiredFilled'
import CircleCloseFilled from '../../svg/CircleCloseFilled'
import ErrorFilled from '../../svg/ErrorFilled'
import RupeeCircleFilled from '../../svg/RupeeCircleFilled'

const LeadsSummary = () => {
  const { data } = useGetLeadCount()
  const navigation = useNavigation()
  return (
    <Stack className="mx-3 mb-3 mt-3">
      <SH3 className="mb-2">{i18n.t('leadsSummary.leadsSummary')}</SH3>
      <Pressable
        className="bg-grays-20 border-grays-30 flex-row items-center border px-2 py-2"
        style={{
          borderTopStartRadius: 8,
          borderTopEndRadius: 8,
        }}
        onPress={() => navigation.navigate('Leads', { leadStatus: 'total' })}
      >
        <AssignedOutlined color={zetColors.primary[100]} />
        <B4 className="text-primary-200 ml-2">
          {i18n.t('leadsSummary.total', { total: data?.data?.total })}
        </B4>
      </Pressable>
      <XStack
        className="border-grays-30 bg-neutral-white100 border px-3 py-3"
        style={{ borderTopWidth: 0 }}
      >
        <Pressable
          onPress={() =>
            navigation.navigate('Leads', {
              leadStatus: 'fullfilled-pfulfilled',
            })
          }
          className=" w-[50%] flex-row "
        >
          <Stack className="bg-grays-20 h-6 w-6 items-center justify-center rounded">
            <RupeeCircleFilled />
          </Stack>
          <Stack className="ml-2">
            <SH3>{data?.data?.saleCompleted}</SH3>
            <B5
              className="text-grays-60
            "
            >
              {i18n.t('leadsSummary.completed')}
            </B5>
          </Stack>
        </Pressable>
        <Stack className=" border-grays-30 border-r"></Stack>
        <Pressable
          onPress={() =>
            navigation.navigate('Leads', {
              leadStatus: 'actnreqrd-leadadded',
            })
          }
          className=" w-[50%] flex-row  pl-3"
        >
          <Stack className="bg-grays-20 h-6 w-6 items-center justify-center rounded">
            <ErrorFilled />
          </Stack>
          <Stack className="ml-2">
            <SH3>{data?.data?.saleIncomplete}</SH3>
            <B5 className="text-grays-60">
              {i18n.t('leadsSummary.inCompleted')}
            </B5>
          </Stack>
        </Pressable>
      </XStack>

      <XStack
        className="bg-neutral-white100 border-grays-30 border px-3 py-3"
        style={{
          borderBottomEndRadius: 4,
          borderBottomStartRadius: 4,
          borderTopWidth: 0,
        }}
      >
        <Pressable
          onPress={() =>
            navigation.navigate('Leads', {
              leadStatus: 'rejected',
            })
          }
          className="w-[50%] flex-row"
        >
          <Stack className="bg-grays-20 h-6 w-6 items-center justify-center rounded">
            <CircleCloseFilled />
          </Stack>
          <Stack className="ml-2">
            <SH3>{data?.data?.rejected}</SH3>
            <B5 className="text-grays-60">{i18n.t('leadsSummary.rejected')}</B5>
          </Stack>
        </Pressable>
        <Stack className=" border-grays-30 border-r"></Stack>
        <Pressable
          onPress={() =>
            navigation.navigate('Leads', {
              leadStatus: 'expired',
            })
          }
          className=" w-[50%] flex-row  pl-3"
        >
          <Stack className="bg-grays-20 h-6 w-6 items-center justify-center rounded">
            <CalenderExpiredFilled />
          </Stack>
          <Stack className="ml-2">
            <SH3>{data?.data?.expired}</SH3>
            <B5 className="text-grays-60">{i18n.t('leadsSummary.expired')}</B5>
          </Stack>
        </Pressable>
      </XStack>
    </Stack>
  )
}

export default LeadsSummary
